import { render, staticRenderFns } from "./loyaltyMilestone.vue?vue&type=template&id=63f5f9c8&scoped=true"
import script from "./loyaltyMilestone.vue?vue&type=script&lang=js"
export * from "./loyaltyMilestone.vue?vue&type=script&lang=js"
import style0 from "./loyaltyMilestone.vue?vue&type=style&index=0&id=63f5f9c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5f9c8",
  null
  
)

export default component.exports